import { render, staticRenderFns } from "./TemplateEditing.vue?vue&type=template&id=47b8a314"
import script from "./TemplateEditing.vue?vue&type=script&lang=js"
export * from "./TemplateEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports